// TOOLS
import cookie from './tools/cookie.es6';
// FUNCTIONALITY
import ui from './ui.es6';

$(document).ready(function () {
    /**
     * Ajax setup
     */
    let csrf = cookie.getCookie('csrftoken');
    $.ajaxSetup({headers: {'X-CSRFToken': csrf}});

    /**
     * UI utils
     * class to put JS front-end code
     */
    ui.ready();

    const search_form_recaptcha_selector = '#property_search_form .grecaptcha-badge';
    waitForElement(search_form_recaptcha_selector, function (e) {
        $(search_form_recaptcha_selector).appendTo('body');  // Move the badge out of the modal
        grecaptcha.reset();  // Needed to have the captcha field after removing the badge from the modal
    });

    const $modalSendPolicyInfoEmail = $('#modal-send-policy-info-email');
    const $resultContainer = $("#results-confirm .modal-content");
    const $alertSuccess = $('.policy-info-sent');

    $('.result-single').click(function () {
        $alertSuccess.hide();
        let idUef = $(this).attr("data-id-uef");
        if (idUef) {
            $('input[name="id_uef"]', $modalSendPolicyInfoEmail).val(idUef);
            $resultContainer.html("");
            $.get(ajax_get_adresse_url, {'id_uef': idUef}, function (data) {
                $resultContainer.html(data['partial_view']);
            });
        }
    });

    $('#form-send-policy-info-email').submit(function (e) {
        e.preventDefault();
        let $submitBtn = $('.cta', $(this));
        if ($submitBtn.hasClass('loading')) return;
        $submitBtn.addClass('loading');

        var slider = document.getElementById('results_slider_amount');
        if (slider) {
            $('#hidden_amount_to_insured').val(slider.value);
        }

        $.post($(this).attr('action'), $(this).serialize(), function (response_data) {
            $submitBtn.removeClass('loading');
            if (response_data['success']) {
                $modalSendPolicyInfoEmail.modal('hide');
                $alertSuccess.html(response_data['message']).show();
                window.scrollTo(0, 0);
            }
        })
    })
});

$(window).on('load', () => {
    ui.loaded();
});

function waitForElement(selector, callback) {
    if ($(selector).length) {
        callback();
    } else {
        setTimeout(function () {
            waitForElement(selector, callback);
        }, 100);
    }
}